/** Base64 PCM 编解码（避免在热路径里重复写 atob 循环） */

export function decodeBase64ToArrayBuffer(base64: string): ArrayBuffer {
    let raw = base64;
    const prefix = "base64,";
    const idx = raw.indexOf(prefix);
    if (raw.startsWith("data:") && idx >= 0) {
        raw = raw.slice(idx + prefix.length);
    }
    const binary = atob(raw);
    const bytes = new Uint8Array(binary.length);
    for (let i = 0; i < binary.length; i++) {
        bytes[i] = binary.charCodeAt(i);
    }
    return bytes.buffer;
}

/** Int16 PCM 需要偶数字节；奇数则截掉最后一个字节 */
export function toEvenArrayBuffer(buffer: ArrayBuffer): ArrayBuffer {
    if (buffer.byteLength % 2 === 0) return buffer;
    return buffer.slice(0, buffer.byteLength - 1);
}

export function silencePcmBuffer(
    durationMs: number,
    sampleRate: number,
): ArrayBuffer {
    const samples = Math.max(0, Math.round((sampleRate * durationMs) / 1000));
    return new ArrayBuffer(samples * 2);
}

export function pcmDurationMs(
    byteLength: number,
    sampleRate: number,
): number {
    return Math.ceil((byteLength / 2 / sampleRate) * 1000);
}

export function concatInt16(chunks: Int16Array[]): Int16Array {
    let total = 0;
    for (const chunk of chunks) total += chunk.length;
    const merged = new Int16Array(total);
    let offset = 0;
    for (const chunk of chunks) {
        merged.set(chunk, offset);
        offset += chunk.length;
    }
    return merged;
}

export function concatArrayBuffers(chunks: ArrayBuffer[]): ArrayBuffer {
    let total = 0;
    for (const chunk of chunks) total += chunk.byteLength;
    const merged = new Uint8Array(total);
    let offset = 0;
    for (const chunk of chunks) {
        merged.set(new Uint8Array(chunk), offset);
        offset += chunk.byteLength;
    }
    return merged.buffer;
}

/** 句首补静音，方便数字人起播；不再复制句首 PCM（复制会叠读） */
export function padTtsOnset(
    samples: Int16Array,
    sampleRate: number,
    silenceMs: number,
): Int16Array {
    const silenceCount = Math.max(
        0,
        Math.round((sampleRate * silenceMs) / 1000),
    );
    if (silenceCount <= 0) return samples;
    return concatInt16([new Int16Array(silenceCount), samples]);
}

/** 从队列头部取出最多 count 个样本（会改写 chunks） */
export function takeInt16(chunks: Int16Array[], count: number): Int16Array {
    if (count <= 0 || chunks.length === 0) return new Int16Array(0);
    const out = new Int16Array(count);
    let filled = 0;
    while (filled < count && chunks.length > 0) {
        const head = chunks[0]!;
        const need = count - filled;
        if (head.length <= need) {
            out.set(head, filled);
            filled += head.length;
            chunks.shift();
        } else {
            out.set(head.subarray(0, need), filled);
            chunks[0] = head.subarray(need);
            filled += need;
        }
    }
    return filled === count ? out : out.subarray(0, filled);
}
